import React from 'react';
import { Container, Typography, Grid, List, ListItem, Button, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import './main.css';  // Import custom styles if needed
import AOS from 'aos';
import 'aos/dist/aos.css';

// Initialize AOS
AOS.init({
  duration: 1000, // Animation duration
  once: true, // Only animate once on scroll
});

function About({ darkMode }) {
  const points = [
    "Integrity: We adhere to the highest ethical standards and transparency in all our dealings.",
    "Client-Centric Approach: We listen, understand, and tailor solutions that best suit our clients' needs.",
    "Excellence: We are committed to delivering top-notch services that exceed expectations."
  ];

  return (
    <section
      id="about"
      className="about section"
      style={{
        backgroundColor: darkMode ? '#000' : '#f9f9f9',
        color: darkMode ? '#fff' : '#333',
        padding: '4rem 0'
      }}
    >
      <Container maxWidth="lg" style={{ marginTop: '2rem', padding: '2rem' }}>
        {/* Section Title */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          data-aos="fade-up"
          style={{ fontWeight: 700, color: darkMode ? '#fff' : '#333' }}
        >
          About Us
        </Typography>
        <Typography
          variant="body1"
          align="center"
          gutterBottom
          data-aos="fade-up"
          style={{ color: darkMode ? '#ccc' : '#666' }}
        >
          Who we are
        </Typography>

        {/* Content Grid */}
        <Grid container spacing={4} style={{ marginTop: '3rem' }}>
          {/* Left Column */}
          <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="100">
            <Typography
              variant="body1"
              style={{
                color: darkMode ? '#ddd' : '#444',
                marginBottom: '1.5rem',
                lineHeight: '1.75'
              }}
            >
              Welcome to Fincal Business Solutions! We are a leading accounting firm committed to delivering expert financial guidance
              and support to businesses of all sizes. With our personalized approach, we help streamline your financial operations,
              ensuring compliance and accuracy in every aspect of accounting and taxation.
            </Typography>

            {/* Key Points List */}
            <List>
              {points.map((point, index) => (
                <ListItem key={index} data-aos="fade-up" data-aos-delay={`${150 * (index + 1)}`}>
                  <ListItemIcon>
                    <CheckCircleIcon color="warning" style={{ fontSize: '2rem' }} />
                  </ListItemIcon>
                  <ListItemText
                    primary={point}
                    style={{
                      color: darkMode ? '#fff' : '#333',
                      fontSize: '1.1rem'
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="200">
            <Typography
              variant="body1"
              style={{
                color: darkMode ? '#ddd' : '#444',
                marginBottom: '1.5rem',
                lineHeight: '1.75'
              }}
            >
              At Fincal Business Solutions, we believe in providing comprehensive financial management solutions that are tailored to meet
              the unique needs of every client. With years of experience in accounting, tax services, and financial planning, our team is
              equipped to help you navigate complex financial landscapes.
            </Typography>

            {/* Read More Button */}
            <Button
              variant="contained"
              color="warning"
              className="read-more"
              style={{
                marginTop: '2rem',
                padding: '0.8rem 2rem',
                fontSize: '1rem',
                backgroundColor: '#fd7e14',
                color: '#fff',
                 
                transition: 'background-color 0.3s ease',
              }}
              href="/about"
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#e6730f')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#fd7e14')}
              data-aos="fade-up"
              data-aos-delay="300"
            >
              Read More
            </Button>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

export default About;
